/* eslint-disable @typescript-eslint/no-unused-vars */
import {
    Box,
    Pagination,
    PaginationItem,
    Typography,
    Select as SelectElement,
    MenuItem as MenuItemElement,
    Stack,
    Button,
} from '@mui/material';
import { unstable_useId as useId } from '@mui/material/utils';
import {
    useSlotProps,
    WithOptionalOwnerState,
    isHostComponent,
} from '@mui/base/utils';
import React, { ReactElement, Ref, useCallback, useContext } from 'react';
import type {
    LabelDisplayedRowsArgs,
    TablePaginationProps,
} from '@mui/material/TablePagination';
import TablePaginationActions from '@mui/material/TablePagination/TablePaginationActions';
import { AppButton } from './AppComponents';
import { ChevronLeft, ChevronRight } from './AppIcons';

interface paginationContext {
    pageNum: number;
    activeFirst: boolean;
    activeLast: boolean;
    setActiveLast: React.Dispatch<React.SetStateAction<boolean>>;
    setActiveFirst: React.Dispatch<React.SetStateAction<boolean>>;
}
const PaginationContext = React.createContext<paginationContext | null>(null);
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const ButtonPagination = (props: any) => {
    const PageContext = useContext(PaginationContext);
    const currentPaginationNum = React.useMemo(() => {
        if (
            // eslint-disable-next-line react/destructuring-assignment
            props.children &&
            // eslint-disable-next-line react/destructuring-assignment
            Array.isArray(props.children) &&
            // eslint-disable-next-line react/destructuring-assignment
            props.children.length > 0
        ) {
            // eslint-disable-next-line react/destructuring-assignment
            const firstChildren = props.children.at(0);
            if (
                firstChildren &&
                Array.isArray(firstChildren) &&
                firstChildren.length > 0
            ) {
                const dutiesNum = firstChildren.at(0);
                if (dutiesNum && typeof dutiesNum === 'number') {
                    return dutiesNum;
                }
            }
        }
        return -1;
        // eslint-disable-next-line react-hooks/exhaustive-deps, react/destructuring-assignment
    }, [props.children]);
    const currentPrev = React.useMemo(() => {
        if (
            // eslint-disable-next-line react/destructuring-assignment
            props.children &&
            // eslint-disable-next-line react/destructuring-assignment
            Array.isArray(props.children) &&
            // eslint-disable-next-line react/destructuring-assignment
            props.children.length > 0
        ) {
            // eslint-disable-next-line react/destructuring-assignment
            const firstChildren = props.children.at(0);
            if (
                firstChildren &&
                Array.isArray(firstChildren) &&
                firstChildren.length > 0
            ) {
                const dutiesPrev = firstChildren.at(1);
                if (
                    dutiesPrev &&
                    dutiesPrev.props &&
                    dutiesPrev.props.ownerState &&
                    dutiesPrev.props.ownerState.type === 'previous'
                ) {
                    return true;
                }
            }
        }
        return false;
        // eslint-disable-next-line react-hooks/exhaustive-deps, react/destructuring-assignment
    }, [props.children]);

    const currentNext = React.useMemo(() => {
        if (
            // eslint-disable-next-line react/destructuring-assignment
            props.children &&
            // eslint-disable-next-line react/destructuring-assignment
            Array.isArray(props.children) &&
            // eslint-disable-next-line react/destructuring-assignment
            props.children.length > 0
        ) {
            // eslint-disable-next-line react/destructuring-assignment
            const firstChildren = props.children.at(0);
            if (
                firstChildren &&
                Array.isArray(firstChildren) &&
                firstChildren.length > 0
            ) {
                const dutiesPrev = firstChildren.at(1);
                if (
                    dutiesPrev &&
                    dutiesPrev.props &&
                    dutiesPrev.props.ownerState &&
                    dutiesPrev.props.ownerState.type === 'next'
                ) {
                    return true;
                }
            }
        }
        return false;
        // eslint-disable-next-line react-hooks/exhaustive-deps, react/destructuring-assignment
    }, [props.children]);
    React.useEffect(() => {
        if (
            currentPaginationNum > -1 &&
            // eslint-disable-next-line react/destructuring-assignment
            props.className &&
            // eslint-disable-next-line react/destructuring-assignment
            typeof props.className === 'string' &&
            // eslint-disable-next-line react/destructuring-assignment
            props.className.includes('Mui-selected') &&
            (PageContext?.pageNum === currentPaginationNum ||
                currentPaginationNum === 1)
        ) {
            if (currentPaginationNum === 1) {
                PageContext?.setActiveFirst(true);
                PageContext?.setActiveLast(false);
            } else {
                PageContext?.setActiveFirst(false);
                PageContext?.setActiveLast(true);
            }
        }
        // eslint-disable-next-line react/destructuring-assignment
    }, [PageContext, currentPaginationNum, props.className]);
    return (
        <Button
            {...props}
            disabled={
                (currentPrev && PageContext?.activeFirst) ||
                (currentNext && PageContext?.activeLast) ||
                // eslint-disable-next-line react/destructuring-assignment
                props.disable
            }
        />
    );
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const TextPagination = (props: any) => {
    const PageContext = useContext(PaginationContext);
    const currentPaginationNum = React.useMemo(() => {
        if (
            // eslint-disable-next-line react/destructuring-assignment
            props.children &&
            // eslint-disable-next-line react/destructuring-assignment
            Array.isArray(props.children) &&
            // eslint-disable-next-line react/destructuring-assignment
            props.children.length > 0
        ) {
            // eslint-disable-next-line react/destructuring-assignment
            const firstChildren = props.children.at(0);
            if (
                firstChildren &&
                Array.isArray(firstChildren) &&
                firstChildren.length > 0
            ) {
                const dutiesNum = firstChildren.at(0);
                if (dutiesNum && typeof dutiesNum === 'number') {
                    return dutiesNum;
                }
            }
        }
        return -1;
        // eslint-disable-next-line react-hooks/exhaustive-deps, react/destructuring-assignment
    }, [props.children]);
    const currentPrev = React.useMemo(() => {
        if (
            // eslint-disable-next-line react/destructuring-assignment
            props.children &&
            // eslint-disable-next-line react/destructuring-assignment
            Array.isArray(props.children) &&
            // eslint-disable-next-line react/destructuring-assignment
            props.children.length > 0
        ) {
            // eslint-disable-next-line react/destructuring-assignment
            const firstChildren = props.children.at(0);
            if (
                firstChildren &&
                Array.isArray(firstChildren) &&
                firstChildren.length > 0
            ) {
                const dutiesPrev = firstChildren.at(1);
                if (
                    dutiesPrev &&
                    dutiesPrev.props &&
                    dutiesPrev.props.ownerState &&
                    dutiesPrev.props.ownerState.type === 'previous'
                ) {
                    return true;
                }
            }
        }
        return false;
        // eslint-disable-next-line react-hooks/exhaustive-deps, react/destructuring-assignment
    }, [props.children]);

    const currentNext = React.useMemo(() => {
        if (
            // eslint-disable-next-line react/destructuring-assignment
            props.children &&
            // eslint-disable-next-line react/destructuring-assignment
            Array.isArray(props.children) &&
            // eslint-disable-next-line react/destructuring-assignment
            props.children.length > 0
        ) {
            // eslint-disable-next-line react/destructuring-assignment
            const firstChildren = props.children.at(0);
            if (
                firstChildren &&
                Array.isArray(firstChildren) &&
                firstChildren.length > 0
            ) {
                const dutiesPrev = firstChildren.at(1);
                if (
                    dutiesPrev &&
                    dutiesPrev.props &&
                    dutiesPrev.props.ownerState &&
                    dutiesPrev.props.ownerState.type === 'next'
                ) {
                    return true;
                }
            }
        }
        return false;
        // eslint-disable-next-line react-hooks/exhaustive-deps, react/destructuring-assignment
    }, [props.children]);
    React.useEffect(() => {
        if (
            currentPaginationNum > -1 &&
            // eslint-disable-next-line react/destructuring-assignment
            props.className &&
            // eslint-disable-next-line react/destructuring-assignment
            typeof props.className === 'string' &&
            // eslint-disable-next-line react/destructuring-assignment
            props.className.includes('Mui-selected') &&
            PageContext?.pageNum === currentPaginationNum &&
            currentPaginationNum === 1
        ) {
            PageContext?.setActiveFirst(true);
            PageContext?.setActiveLast(true);
        } else if (
            currentPaginationNum > -1 &&
            // eslint-disable-next-line react/destructuring-assignment
            props.className &&
            // eslint-disable-next-line react/destructuring-assignment
            typeof props.className === 'string' &&
            // eslint-disable-next-line react/destructuring-assignment
            props.className.includes('Mui-selected') &&
            (PageContext?.pageNum === currentPaginationNum ||
                currentPaginationNum === 1)
        ) {
            if (currentPaginationNum === 1) {
                PageContext?.setActiveFirst(true);
                PageContext?.setActiveLast(false);
            } else {
                PageContext?.setActiveFirst(false);
                PageContext?.setActiveLast(true);
            }
        } else if (
            currentPaginationNum > -1 &&
            // eslint-disable-next-line react/destructuring-assignment
            props.className &&
            // eslint-disable-next-line react/destructuring-assignment
            typeof props.className === 'string' &&
            // eslint-disable-next-line react/destructuring-assignment
            props.className.includes('Mui-selected') &&
            (PageContext?.pageNum !== currentPaginationNum ||
                currentPaginationNum !== 1)
        ) {
            PageContext?.setActiveFirst(false);
            PageContext?.setActiveLast(false);
        }
        // eslint-disable-next-line react/destructuring-assignment
    }, [PageContext, currentPaginationNum, props.className]);

    const currentFirst = React.useMemo(() => {
        if (
            // eslint-disable-next-line react/destructuring-assignment
            props.children &&
            // eslint-disable-next-line react/destructuring-assignment
            Array.isArray(props.children) &&
            // eslint-disable-next-line react/destructuring-assignment
            props.children.length > 0
        ) {
            // eslint-disable-next-line react/destructuring-assignment
            const firstChildren = props.children.at(0);
            if (
                firstChildren &&
                Array.isArray(firstChildren) &&
                firstChildren.length > 0
            ) {
                const dutiesPrev = firstChildren.at(1);
                if (
                    dutiesPrev &&
                    dutiesPrev.props &&
                    dutiesPrev.props.ownerState &&
                    dutiesPrev.props.ownerState.type === 'first'
                ) {
                    return true;
                }
            }
        }
        return false;
        // eslint-disable-next-line react-hooks/exhaustive-deps, react/destructuring-assignment
    }, [props.children]);

    const currentLast = React.useMemo(() => {
        if (
            // eslint-disable-next-line react/destructuring-assignment
            props.children &&
            // eslint-disable-next-line react/destructuring-assignment
            Array.isArray(props.children) &&
            // eslint-disable-next-line react/destructuring-assignment
            props.children.length > 0
        ) {
            // eslint-disable-next-line react/destructuring-assignment
            const firstChildren = props.children.at(0);
            if (
                firstChildren &&
                Array.isArray(firstChildren) &&
                firstChildren.length > 0
            ) {
                const dutiesPrev = firstChildren.at(1);
                if (
                    dutiesPrev &&
                    dutiesPrev.props &&
                    dutiesPrev.props.ownerState &&
                    dutiesPrev.props.ownerState.type === 'last'
                ) {
                    return true;
                }
            }
        }
        return false;
        // eslint-disable-next-line react-hooks/exhaustive-deps, react/destructuring-assignment
    }, [props.children]);
    const outlinedButton = React.useMemo(
        () => currentPrev || currentFirst || currentNext || currentLast,
        [currentPrev, currentFirst, currentNext, currentLast]
    );

    return (
        <Button
            {...props}
            variant="text"
            className={
                outlinedButton
                    ? // eslint-disable-next-line react/destructuring-assignment
                      `${`${props.className} outline`}`
                    : // eslint-disable-next-line react/destructuring-assignment
                      props.className
            }
            disabled={
                (currentPrev && PageContext?.activeFirst) ||
                (currentFirst && PageContext?.activeFirst) ||
                (currentNext && PageContext?.activeLast) ||
                (currentLast && PageContext?.activeLast) ||
                // eslint-disable-next-line react/destructuring-assignment
                props.disable
            }
        />
    );
};
/**
 * Props for PaginationComp component.
 */
type PaginationCompProps = {
    className: string;
    data: number; // Total number of data items
    page: number; // Current page number
    onChange: (event: any, newPage: number) => void; // Callback function for page change event
    filter?: number;
    innerRef?: Ref<HTMLDivElement>;
};

type OmitTablePaginationProps = Omit<TablePaginationProps, 'onChange'>;

type FlatPaginationCompProps = OmitTablePaginationProps & {
    className: string;
    containerClassName: string;
    data: number; // Total number of data items
    page: number; // Current page number
    onChange: (event: any, newPage: number) => void; // Callback function for page change event
    filter?: number;
    selectId?: any;
    hidden: boolean;
    slotProps?: any;
    slots?: any;
    innerRef?: Ref<HTMLDivElement>;
    labelId?: string;
    popupPrevNext?: boolean;
};

/**
 * PaginationComp component.
 * @param {PaginationCompProps} props - The props for the component.
 * @returns {ReactElement} The rendered PaginationComp component.
 */
const PaginationComp: React.FC<PaginationCompProps> = ({
    data,
    page,
    onChange,
    filter,
    innerRef,
    className,
}): ReactElement => {
    const [activeLast, setActiveLast] = React.useState<boolean>(false);
    const [activeFirst, setActiveFirst] = React.useState<boolean>(false);

    const initialPaginationContext = React.useMemo(
        () => ({
            pageNum: Math.ceil(data / (filter || 5)),
            activeLast,
            setActiveLast,
            activeFirst,
            setActiveFirst,
        }),
        [activeFirst, activeLast, data, filter]
    );
    /**
     * Renders the label for prev pagination item.
     * @returns {ReactElement} The rendered label for next pagination item.
     */
    const renderPrevLabel = (): ReactElement => <Typography>Prev</Typography>;
    /**
     * Renders the label for next pagination item.
     * @returns {ReactElement} The rendered label for next pagination item.
     */
    const renderNextLabel = (): ReactElement => <Typography>Next</Typography>;

    return (
        <PaginationContext.Provider value={initialPaginationContext}>
            <Pagination
                ref={innerRef}
                className={className}
                count={Math.ceil(data / (filter || 5))}
                page={page + 1}
                onChange={onChange}
                renderItem={(item) => (
                    <PaginationItem
                        component={ButtonPagination}
                        components={{
                            previous: renderPrevLabel,
                            next: renderNextLabel,
                        }}
                        {...item}
                        disabled={item.selected === true}
                    />
                )}
            />
        </PaginationContext.Provider>
    );
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function defaultGetAriaLabel(type: any) {
    return `Go to ${type} page`;
}
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function defaultLabelDisplayedRows({
    from,
    to,
    count,
}: LabelDisplayedRowsArgs) {
    return `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`;
}
/**
 * PaginationComp component.
 * @param {PaginationCompProps} props - The props for the component.
 * @returns {ReactElement} The rendered PaginationComp component.
 */
export const FlatPaginationComp: React.FC<FlatPaginationCompProps> = (
    props
): ReactElement => {
    const {
        colSpan: colSpanProp,
        count,
        getItemAriaLabel = defaultGetAriaLabel,
        labelDisplayedRows = defaultLabelDisplayedRows,
        labelId: labelIdProp,
        labelRowsPerPage = 'Rows per page:',

        onRowsPerPageChange,
        page,
        rowsPerPage,
        rowsPerPageOptions = [10, 25, 50, 100],
        selectId: selectIdProp,
        slotProps = {},
        slots = {},
        data,
        onChange,
        filter,
        innerRef,
        className,
        containerClassName,
        hidden,
        popupPrevNext,
        ...other
    } = props;

    const ownerState = props;
    const [activeLast, setActiveLast] = React.useState<boolean>(false);
    const [activeFirst, setActiveFirst] = React.useState<boolean>(false);

    const initialPaginationContext = React.useMemo(
        () => ({
            pageNum: Math.ceil(data / (rowsPerPage || 5)),
            activeLast,
            setActiveLast,
            activeFirst,
            setActiveFirst,
        }),
        [activeFirst, activeLast, data, filter]
    );
    let colSpan;
    const Root = slots.root ?? 'td';
    if (Root === 'td' || !isHostComponent(Root)) {
        colSpan = colSpanProp || 1000; // col-span over everything
    }

    const selectId = useId(selectIdProp);
    const labelId = useId(labelIdProp);

    const rootProps: WithOptionalOwnerState<any> = useSlotProps({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            colSpan,
        },
        ownerState,
        className: ['root'],
    });

    const Select = slots.select ?? SelectElement;
    const selectProps: WithOptionalOwnerState<any> = useSlotProps({
        elementType: Select,
        externalSlotProps: slotProps.select,
        additionalProps: {
            value: rowsPerPage,
            id: selectId,
            onChange: (
                event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
            ) => onRowsPerPageChange && onRowsPerPageChange(event),
            'aria-label': rowsPerPage ? rowsPerPage.toString() : '',
            'aria-labelledby':
                [labelId, selectId].filter(Boolean).join(' ') || undefined,
        },
        ownerState,
        className: ['select'],
    });

    const MenuItem = slots.menuItem ?? MenuItemElement;
    const menuItemProps: WithOptionalOwnerState<any> = useSlotProps({
        elementType: MenuItem,
        externalSlotProps: slotProps.menuItem,
        additionalProps: {
            value: undefined,
        },
        ownerState,
        className: ['menuItem'],
    });

    const SelectLabel = slots.selectLabel ?? Typography;
    const selectLabelProps: WithOptionalOwnerState<any> = useSlotProps({
        elementType: SelectLabel,
        externalSlotProps: slotProps.selectLabel,
        additionalProps: {
            id: labelId,
        },
        ownerState,
        className: ['selectLabel'],
    });

    const DisplayedRows = slots.displayedRows ?? 'p';
    const displayedRowsProps: WithOptionalOwnerState<any> = useSlotProps({
        elementType: DisplayedRows,
        externalSlotProps: slotProps.displayedRows,
        ownerState,
        className: ['displayedRows'],
    });

    const Toolbar = slots.toolbar ?? 'div';
    const toolbarProps: WithOptionalOwnerState<any> = useSlotProps({
        elementType: Toolbar,
        externalSlotProps: slotProps.toolbar,
        ownerState,
        className: ['toolbar'],
    });

    const Spacer = slots.spacer ?? 'div';
    const spacerProps: WithOptionalOwnerState<any> = useSlotProps({
        elementType: Spacer,
        externalSlotProps: slotProps.spacer,
        ownerState,
        className: ['spacer'],
    });

    /**
     * Renders the label for previous pagination item.
     * @returns {ReactElement} The rendered label for previous pagination item.
     */
    const renderSelectorRowsPerPage = (): ReactElement => (
        <Box class="flat-pagination-content">
            <Stack direction="row" spacing={2} alignItems="center">
                {rowsPerPageOptions.length > 1 && (
                    <SelectLabel {...selectLabelProps}>
                        {labelRowsPerPage}
                    </SelectLabel>
                )}

                {rowsPerPageOptions.length > 1 && (
                    <Select {...selectProps}>
                        {rowsPerPageOptions.map(
                            (
                                rowsPerPageOption:
                                    | number
                                    | { label: string; value: number }
                            ) => (
                                <MenuItem
                                    {...menuItemProps}
                                    key={
                                        typeof rowsPerPageOption !== 'number' &&
                                        rowsPerPageOption.label
                                            ? rowsPerPageOption.label
                                            : rowsPerPageOption
                                    }
                                    value={
                                        typeof rowsPerPageOption !== 'number' &&
                                        rowsPerPageOption.value
                                            ? rowsPerPageOption.value
                                            : rowsPerPageOption
                                    }
                                >
                                    {typeof rowsPerPageOption !== 'number' &&
                                    rowsPerPageOption.label
                                        ? rowsPerPageOption.label
                                        : rowsPerPageOption}
                                </MenuItem>
                            )
                        )}
                    </Select>
                )}
            </Stack>
            <Spacer {...spacerProps} />
        </Box>
    );

    /**
     * Renders the label for previous pagination item.
     * @returns {ReactElement} The rendered label for previous pagination item.
     */
    const renderFirstLabel = (): ReactElement => <Typography>First</Typography>;

    /**
     * Renders the label for next pagination item.
     * @returns {ReactElement} The rendered label for next pagination item.
     */
    const renderLastLabel = (): ReactElement => <Typography>Last</Typography>;

    /**
     * Renders the label for prev pagination item.
     * @returns {ReactElement} The rendered label for next pagination item.
     */
    const renderPrevLabel = (): ReactElement => <ChevronLeft />;
    /**
     * Renders the label for next pagination item.
     * @returns {ReactElement} The rendered label for next pagination item.
     */
    const renderNextLabel = (): ReactElement => <ChevronRight />;

    const handlePrevButton = useCallback(
        (event: any) => {
            if (typeof onChange === 'function') {
                onChange(event, page);
            }
        },
        [onChange, page]
    );
    const handleNextButton = useCallback(
        (event: any) => {
            onChange(event, page + 2);
        },
        [onChange, page]
    );

    return (
        <Box
            className={`flat-pagination-wrapper ${containerClassName}`}
            ref={innerRef}
        >
            <PaginationContext.Provider value={initialPaginationContext}>
                <Box className="flat-pagination">
                    {hidden === false && renderSelectorRowsPerPage()}

                    {hidden === false && (
                        <Pagination
                            className={`${className}`}
                            count={count}
                            page={page + 1}
                            showLastButton
                            showFirstButton
                            hideNextButton={popupPrevNext !== true}
                            hidePrevButton={popupPrevNext !== true}
                            onChange={onChange}
                            renderItem={(item) => (
                                <PaginationItem
                                    component={TextPagination}
                                    components={{
                                        previous: renderPrevLabel,
                                        next: renderNextLabel,
                                        first: renderFirstLabel,
                                        last: renderLastLabel,
                                    }}
                                    {...item}
                                    disabled={item.selected === true}
                                />
                            )}
                        />
                    )}
                    {hidden === false && popupPrevNext !== true && (
                        <Stack
                            direction="row"
                            spacing={2}
                            className="flat-pagination-button"
                        >
                            <AppButton
                                variant="text"
                                className="prevnextButton"
                                title="Prev"
                                disabled={page < 1}
                                onClick={handlePrevButton}
                            />

                            <AppButton
                                variant="text"
                                disabled={page + 1 >= count}
                                onClick={handleNextButton}
                                className="prevnextButton"
                                title="Next"
                            />
                        </Stack>
                    )}
                </Box>
            </PaginationContext.Provider>
        </Box>
    );
};
export default PaginationComp;
